import angular from "angular";
import template from "./instructor-invitations.html";
import AdminInstructorInvitationsController from "./instructor-invitations.controller";
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.instructors.invitations", {
    url: "/invitations",
    controller: AdminInstructorInvitationsController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
        USER_ROLES.staff,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.invitations", [])
  .config(config)
  .controller(
    "AdminInstructorInvitationsController",
    AdminInstructorInvitationsController,
  );
